import React, {useState, useEffect, Fragment} from 'react'
import {Menu, Icon, Button, Label} from 'semantic-ui-react'
import {DragHandle} from './drag_handle'
import {SortableElement} from 'react-sortable-hoc';

export const SortableItem = SortableElement(({item, ungroup, mode, release, edit, editMarkets, open, isFirst, isLast}) => {
    let cnt = {
        active: 0,
        inactive: 0,
        total: 0
    };

    if((typeof item['event-count'] !== 'undefined')){
        for(let status in item['event-count']){
            if(status === 'active')
                cnt.active += item['event-count'][status];
            else
                cnt.inactive += item['event-count'][status];
            
            cnt.total += item['event-count'][status];
        }
    }

		return (
			<Menu.Item link onClick={() => open(item.uid)}active={(typeof item.active !== 'undefined' && item.active)} style={
				
					(typeof item._partOf !== 'undefined' && item._partOf !== null)?
						{
							'marginLeft': '70px',
							backgroundColor: cnt.active?'#FFFFFF':'#EEEEEE'
						}
					:{backgroundColor: (cnt.active)?'#FFFFFF':'#EEEEEE'}
				}>
				<DragHandle isFirst={isFirst} isLast={isLast} />
				{
					(typeof item._structure !== 'undefined' && (typeof item._structure.after !== 'undefined' || typeof item._structure['is-first'] !== 'undefined'))?
						 <span>
						 <Button title="Von fester Position lösen" onClick={(e, data) => {
						 		e.stopPropagation();
						 		release(item.id)
						 	}} compact basic icon style={{
						 	backgroundColor: 'transparent',
			          		boxShadow: 'none',
			          		margin: '-19px 3.5px -19px 0px'
						 }}>
						 {
						 	<Icon name="pin" />
						 }
						 </Button>
						 <span style={{
						 	position: 'absolute',
						 	top: '-14px',
						 	left: '-10px',
						 	width: '14px',
						 	height: '28px',
						 	borderTopLeftRadius: '14px',
						 	borderBottomLeftRadius: '14px',
						 	borderLeft: '1px solid rgb(0, 110, 215)',
						 	borderTop: '1px solid rgb(0, 110, 215)',
						 	borderBottom: '1px solid rgb(0, 110, 215)'
						 }}>
						 	<span style={{
						 		width: '4px',
						 		height: '4px',
						 		borderRadius: '4px',
						 		backgroundColor: 'rgb(0, 110, 215)',
						 		display: 'block',
						 		position: 'absolute',
						 		right: '-2px',
						 		top: '-2px'
						 	}}></span>
						 	<span style={{
						 		width: '4px',
						 		height: '4px',
						 		borderRadius: '4px',
						 		backgroundColor: 'rgb(0, 110, 215)',
						 		display: 'block',
						 		position: 'absolute',
						 		right: '-2px',
						 		bottom: '-2px'
						 	}}></span>
							 
						 </span>
						</span>
			         :<span style={{
			         	paddingLeft: '36.5px'
			         }}></span>
				}
                <span style={{"width": "200px", display: 'inline-block', fontSize: '0.8em', color: '#0077FF'}}>{(mode === 'cis')?item.category_uid:item.uid}</span>

				{(typeof item.name !== 'undefined')
                        ?item.name
                        :(typeof item.canvas !== 'undefined' && typeof item.canvas.name !== 'undefined')
                            ?item.canvas.name
                            :(typeof item.canvas.canvas !== 'undefined')
                                ?item.canvas.canvas.name
                                :null}
                
                <Label color={(cnt.active)?'blue':'grey'} style={{width: '60px'}}>
    {cnt.active}
  </Label>
                {
                    (mode === 'sport')?
                        <Button onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            editMarkets(item.uid);
                        }} icon size="mini" style={{
                            float: 'right',
                            position: 'relative',
                            top: '-5px'
                        }}><Icon name="list ol" /> Märkte</Button>
                    :null
                }

				<Button onClick={(e) => {
					e.stopPropagation();
					e.preventDefault();
					edit(mode, item.id);
				}} icon size="mini" style={{
                    display: 'none',
					float: 'right',
					position: 'relative',
					top: '-5px'
				}}><Icon name="configure" /> Bearbeiten</Button>
				{
					(typeof item._isParent !== 'undefined' && item._isParent)?
						<Button color="red" onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							ungroup(item.id);
						}} icon size="mini" style={{
							float: 'right',
							position: 'relative',
							top: '-5px'
						}}><Icon name="object ungroup outline" /> Gruppe auflösen</Button>
					:null
				}
				{
					(typeof item._structure !== 'undefined' && typeof item.inherited !== 'undefined' && (typeof item._structure.after !== 'undefined' || typeof item._structure['is-first'] !== 'undefined'))?
						<span style={{
							float: 'right',
							fontStyle: 'italic',
							fontSize: '80%',
							color: '#777777',
							marginRight: '20px'
						}}>(Position von {
							(item.from === 'lottery')
							?<span>Lotterie</span>
							:(item.from === 'channel')
							?<span>Kanal</span>
							:<span>globaler Sortierung</span>
						} übernommen)</span>	
					:null
				}
				
			</Menu.Item>
		)

	}
);